import * as React from "react";
const SvgMove = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="#000" d="M14 15v4.5h3L12.5 24 8 19.5h3V15zM11 9V4.5H8L12.5 0 17 4.5h-3V9z" /></svg>;
export { SvgMove as ReactComponent };